<template>
  <div class="calc">
      <b-form @submit="submit">
<!--        https://docs.microsoft.com/en-us/office/troubleshoot/excel/floating-point-arithmetic-inaccurate-result-->

<!--        <b-button variant="danger" @click="calculate('revenue')">REVENUE</b-button>-->
<!--        <b-button variant="danger" @click="calculate('profit')">PROFITS</b-button>-->
<!--        <b-button @click="assumptions = !assumptions">Toggle Assumptions</b-button>-->
<!--        <b-button @click="clearInputs" >clear inputs</b-button>-->
<!--        <b-button @click="validateInputs" >Validate Test</b-button>-->

<!--        <b-button @click="debugFlag = !debugFlag">Toggle Debug Mode</b-button>-->

<!--        <template v-if="debugFlag">-->
<!--          <div style="width: 500px;">-->
<!--            <i>*** Generate both vacancy calcs first ****</i>-->
<!--            <button @click="createVacancyCostsRevenue">Create Vacancy Cost Rev Bar</button>-->
<!--            <button @click="createVacancyCostsProfit">Create Vacancy Cost Profit Bar</button>-->

<!--            <button @click="calculateTotalLostProductionCostFromTechnicianTurnoverRevenue">Cost Of Turnover (Revenue)</button>-->
<!--            <button @click="calculateTotalLostProductionCostFromTechnicianTurnoverProfit">Cost Of Turnover (Profit)</button>-->

<!--            &lt;!&ndash;          <line-chart :chart-data="datacollection" v-if="datacollection"></line-chart>&ndash;&gt;-->
<!--&lt;!&ndash;            <bar-chart :chart-data="totalCostOfTurnover" title="Total Cost of Turnover" v-if="totalCostOfTurnover"></bar-chart>&ndash;&gt;-->
<!--&lt;!&ndash;            <bar-chart :chart-data="vacancyCosts" title="Vacancy Costs" v-if="vacancyCosts"></bar-chart>&ndash;&gt;-->
<!--&lt;!&ndash;            <bar-chart :chart-data="lostProductionCosts" title="Lost Production Costs" v-if="lostProductionCosts"></bar-chart>&ndash;&gt;-->
<!--&lt;!&ndash;            <pie-chart :chart-data="recruitingCosts" v-if="recruitingCosts"></pie-chart>&ndash;&gt;-->
<!--          </div>-->

<!--          <h4>Vacancy Costs</h4>-->
<!--          <button @click="costOfTurnoverRevenue">costOfTurnoverRevenue</button>-->
<!--          <button @click="costOfTurnoverProfit">costOfTurnoverProfit</button>-->
<!--          <b-button variant="primary"  @click="showcalcs = !showcalcs">Show $data.calculations</b-button>-->
<!--          <template v-if="showcalcs">-->
<!--            <pre>{{ calculations }}</pre>-->
<!--          </template>-->
<!--          <hr class="mt-10">-->

<!--          <h4>Interviewing & Recruiting Costs</h4>-->
<!--          <button @click="calculateHiringManagerCosts">calculateHiringManagerCosts</button>-->
<!--          <button @click="calculateJobPostingCost">calculateJobPostingCost</button>-->
<!--          <button @click="calculateJobScreeningCost">calculateJobScreeningCost</button>-->
<!--          <b-button variant="primary" @click="calculateTotalInterviewingRecruitingCosts" class="primary">Recruiting Costs Totals</b-button>-->
<!--        </template>-->

        <!-- Step One: Positions to fill-->
<!--        <b-form-group-->
<!--          label="Positions To Fill"-->
<!--          label-size="lg"-->
<!--          label-class="font-weight-bold pt-0"-->
<!--          class="mb-0"-->
<!--        >-->
<!--          <b-form-group-->
<!--            id="positions"-->
<!--            label="Turnover Rate"-->
<!--            label-for="turnover_rate"-->
<!--            description="Number of positions that need to be filled during an average year."-->
<!--          >-->
<!--            <b-form-input-->
<!--              id="turnover_rate"-->
<!--              v-model="turnover_rate"-->
<!--              type="number"-->
<!--              placeholder=""-->
<!--              required-->
<!--              disabled-->
<!--            ></b-form-input>-->
<!--          </b-form-group>-->
<!--        </b-form-group>-->


      <div class="form-inner">
        <h1>Technician ROI Calculator Inputs</h1>
        <h2 class="section-header"> Dealership Specific Inputs</h2>

        <p>Input boxes colored gray contain a starting value or industry average.  Modify the values to better represent your Dealer’s situation. </p>
        <h3 class="input-header">New Technician Hires</h3>
        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="new_hire">New hire</label>
<!--              <font-awesome-icon id="tooltip-newhire" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-newhire" placement="right">-->
<!--                Number of technicians hired with no previous experience-->
<!--              </b-tooltip>-->
            </div>
            <input
              id="new_hire"
              v-model="new_hire"
              type="number"
              placeholder=""
              required
              :class="{'error': !new_hire && !clearedInputs, 'empty': clearedInputs, 'default': new_hire === originalValues.new_hire }"
              @focusout="newHireCheck; $event.target.classList.toggle('focused');"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !new_hire">
            <!--          <p class="error-msg" v-if="!new_hire && !clearedInputs">-->
            <font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />
            New Hire is required.</p>
        </div>
        <!-- -->
        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="experienced_hire">Experienced hire</label>
<!--              <font-awesome-icon id="tooltip-experiencedhire" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-experiencedhire" placement="right">-->
<!--                Number of technicians hired with at least one year of previous experience-->
<!--              </b-tooltip>-->
            </div>
            <input
              id="experienced_hire"
              v-model="experienced_hire"
              type="number"
              placeholder=""
              required
              @focusout="experiencedHireCheck; $event.target.classList.toggle('focused');"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors "><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Experienced Hire is required (0 is acceptable).</p>
        </div>

        <!-- VACANCY DAYS  -->
        <h3 class="input-header">Position Opening Days</h3>
        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="vacancy_days">Average number of days a position is left open</label>
<!--              <font-awesome-icon id="tooltip-vac" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-vac" placement="right">-->
<!--                Average number of days a position is vacant-->
<!--              </b-tooltip>-->
            </div>
            <input
              id="vacancy_days"
              v-model="vacancy_days"
              type="number"
              placeholder=""
              required
              :class="{'error': !vacancy_days && !clearedInputs, 'empty': !vacancy_days && clearedInputs, 'default': vacancy_days === originalValues.vacancy_days }"
              @focusout="$event.target.classList.toggle('focused')"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !vacancy_days"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Vacancy Days are required.</p>
        </div>

        <h3 class="input-header">Door Rate <span>
<!--          <input id="elr" type="checkbox" @change="effective_labor_rate_toggle = !effective_labor_rate_toggle"><label-->
<!--          for="elr">Effective Labor Rate</label>-->
        </span></h3>
        <!-- Door Rate  -->
        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="door_rate">Door rate</label>
              <font-awesome-icon id="tooltip-door" class="fa-fw" :icon="['fal', 'info-circle']"/>
              <b-tooltip target="tooltip-door" placement="right">
                Average price paid for service hourly
              </b-tooltip>
            </div>
            <input
              id="door_rate"
              v-model="door_rate"
              type="number"
              placeholder=""
              required
              :class="{'error': !door_rate && !clearedInputs, 'empty': !door_rate && clearedInputs, 'default': door_rate === originalValues.door_rate }"
              @focusout="$event.target.classList.toggle('focused')"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !door_rate"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Door Rate is required.</p>
        </div>

<!--        <div class="input-container" v-if="effective_labor_rate_toggle">-->
<!--          <div class="input">-->
<!--            <div class="tooltip-container">-->
<!--              <label for="effective_labor_rate">Effective Labor Rate</label>-->
<!--              <font-awesome-icon id="tooltip-laborrate" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-laborrate" placement="right">-->
<!--                Average Effective Labor Rate of a New Technician-->
<!--              </b-tooltip>-->
<!--            </div>-->
<!--            <input-->
<!--              id="effective_labor_rate"-->
<!--              v-model="effective_labor_rate"-->
<!--              type="number"-->
<!--              placeholder=""-->
<!--              required-->
<!--              :class="{'error': !effective_labor_rate && !clearedInputs, 'empty': !effective_labor_rate && clearedInputs, 'default': effective_labor_rate === originalValues.effective_labor_rate }"-->
<!--              @focusout="$event.target.classList.toggle('focused')"-->
<!--              @keyup="iValid"-->
<!--              @focusin="iValid"-->
<!--            >-->
<!--          </div>-->
<!--          <p class="error-msg" v-if="errors || !effective_labor_rate"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Effective Labor Rate is required.</p>-->
<!--        </div>-->

        <h2 class="section-header">Training & Onboarding</h2>
        <h3 class="input-header">Training Time</h3>
        <!-- Step Three: Training & Onboarding-->
        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="months_equiv_efficiency">Months for new hire to achieve equivalent efficiency of experienced Technician</label>
<!--              <font-awesome-icon id="tooltip-equiv_efficiency" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-equiv_efficiency" placement="right">-->
<!--                Average number of months for new technician to reach the efficiency of experienced tech-->
<!--              </b-tooltip>-->
            </div>
            <input
              id="months_equiv_efficiency"
              v-model="months_equiv_efficiency"
              type="number"
              placeholder=""
              required
              :class="{'error': !months_equiv_efficiency && !clearedInputs, 'empty': !months_equiv_efficiency && clearedInputs, 'default': months_equiv_efficiency === originalValues.months_equiv_efficiency }"
              @focusout="$event.target.classList.toggle('focused')"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !months_equiv_efficiency"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
        </div>

        <div class="input-container">
          <div class="input">
            <div class="tooltip-container">
              <label for="months_equiv_efficiency_experienced">Months for experienced hire to achieve equivalent efficiency of veteran Technician</label>
<!--              <font-awesome-icon id="tooltip-equiv_efficiency_experienced" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--              <b-tooltip target="tooltip-equiv_efficiency_experienced" placement="right">-->
<!--                Average number of months for experienced technician to reach the efficiency of experienced tech-->
<!--              </b-tooltip>-->
            </div>
            <input
              id="months_equiv_efficiency_experienced"
              v-model="months_equiv_efficiency_experienced"
              type="number"
              placeholder=""
              required
              :class="{'error': !months_equiv_efficiency_experienced && !clearedInputs, 'empty': !months_equiv_efficiency_experienced && clearedInputs, 'default': months_equiv_efficiency_experienced === originalValues.months_equiv_efficiency_experienced }"
              @focusout="$event.target.classList.toggle('focused')"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !months_equiv_efficiency_experienced"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
        </div>

        <div class="input-container">
          <div class="input">
            <label for="avg_time_until_full_prod">Average time until full production (40 hours per week)</label>
            <input
              id="avg_time_until_full_prod"
              v-model="avg_time_until_full_prod"
              type="number"
              placeholder=""
              required
              :class="{'error': !avg_time_until_full_prod && !clearedInputs, 'empty': !avg_time_until_full_prod && clearedInputs, 'default': avg_time_until_full_prod === originalValues.avg_time_until_full_prod }"
              @focusout="$event.target.classList.toggle('focused')"
              @keyup="iValid"
              @focusin="iValid"
            >
          </div>
          <p class="error-msg" v-if="errors || !avg_time_until_full_prod"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
        </div>

        <p class="override-text">When steps 1 through 3 are complete, you may calculate your data or continue to the next section to override the industry standard baseline metrics.</p>

        <b-button
          class="assumption-toggle"
          :class="assumptions ? null : 'collapsed'"
          :aria-expanded="assumptions ? 'true' : 'false'"
          aria-controls="collapse-4"
          @click="assumptions = !assumptions"
        >
          Override Industry Standard Baseline Metrics
          <span v-if="assumptions"><font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-up']" /></span>
          <span v-else><font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-down']" /></span>
        </b-button>

        <b-collapse id="collapse-4" v-model="assumptions" class="" appear>
          <b-card class="assumptions-container">
            <h2 class="section-header">Dealership Metrics</h2>
            <h3 class="input-header">Working Rate</h3>
            <div class="input-container">
              <div class="input">
                <label for="hrs_worked_daily">Hours worked daily</label>
                <input
                  id="hrs_worked_daily"
                  v-model="hrs_worked_daily"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hrs_worked_daily && !clearedInputs, 'empty': !hrs_worked_daily && clearedInputs, 'default': hrs_worked_daily === originalValues.hrs_worked_daily }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hrs_worked_daily"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="days_worked_weekly">Days worked weekly</label>
<!--                  <font-awesome-icon id="tooltip-days_worked_weekly" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-days_worked_weekly" placement="right">-->
<!--                    Average days worked daily by technicians-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="days_worked_weekly"
                  v-model="days_worked_weekly"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !days_worked_weekly && !clearedInputs, 'empty': !days_worked_weekly && clearedInputs, 'default': days_worked_weekly === originalValues.days_worked_weekly }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !days_worked_weekly"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="weeks_worked_yearly">Weeks worked annually</label>
       <!--            <font-awesome-icon id="tooltip-weeks_worked_yearly" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-weeks_worked_yearly" placement="right">
                    Average days worked annually by technicians
                  </b-tooltip> -->
                </div>
                <input
                  id="weeks_worked_yearly"
                  v-model="weeks_worked_yearly"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !weeks_worked_yearly && !clearedInputs, 'empty': !weeks_worked_yearly && clearedInputs, 'default': weeks_worked_yearly === originalValues.weeks_worked_yearly }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !weeks_worked_yearly"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Revenue Percentage</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="percent_rev_labor">Percentage of revenue from labor</label>
<!--                  <font-awesome-icon id="tooltip-percent_rev_labor" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-percent_rev_labor" placement="right">-->
<!--                    Percentage of Revenue from Labor-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="percent_rev_labor"
                  v-model="percent_rev_labor"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !percent_rev_labor && !clearedInputs, 'empty': !percent_rev_labor && clearedInputs, 'default': percent_rev_labor === originalValues.percent_rev_labor }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !percent_rev_labor"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="percent_rev_parts">Percentage of revenue from parts</label>
<!--                  <font-awesome-icon id="tooltip-percent_rev_parts" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-percent_rev_parts" placement="right">-->
<!--                    Percentage of Revenue from Parts-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="percent_rev_parts"
                  v-model="percent_rev_parts"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !percent_rev_parts && !clearedInputs, 'empty': !percent_rev_parts && clearedInputs, 'default': percent_rev_parts === originalValues.percent_rev_parts }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !percent_rev_parts"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Profit Margins</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="labor_profit_margin">Labor profit margin</label>
<!--                  <font-awesome-icon id="tooltip-labor_profit_margin" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-labor_profit_margin" placement="right">-->
<!--                    Profit Margin on labor hours-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="labor_profit_margin"
                  v-model="labor_profit_margin"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !labor_profit_margin && !clearedInputs, 'empty': !labor_profit_margin && clearedInputs, 'default': labor_profit_margin === originalValues.labor_profit_margin }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !labor_profit_margin"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="parts_profit_margin">Parts profit margin</label>
<!--                  <font-awesome-icon id="tooltip-parts_profit_margin" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-parts_profit_margin" placement="right">-->
<!--                    Profit Margin on parts-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="parts_profit_margin"
                  v-model="parts_profit_margin"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !parts_profit_margin && !clearedInputs, 'empty': !parts_profit_margin && clearedInputs, 'default': parts_profit_margin === originalValues.parts_profit_margin }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !parts_profit_margin"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h2 class="section-header">Technician Efficiency and Productivity Metrics</h2>
            <h3 class="input-header">Efficiency</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="initial_efficiency_new_hire">Initial Efficiency Ratio of a new hire</label>
                  <font-awesome-icon id="tooltip-initial_efficiency_new_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-initial_efficiency_new_hire" placement="right">
                    Efficiency rate of new Technicians completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="initial_efficiency_new_hire"
                  v-model="initial_efficiency_new_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !initial_efficiency_new_hire && !clearedInputs, 'empty': !initial_efficiency_new_hire && clearedInputs, 'default': initial_efficiency_new_hire === originalValues.initial_efficiency_new_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !initial_efficiency_new_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="initial_efficiency_experienced_hire">Initial efficiency of an experienced hire</label>
                  <font-awesome-icon id="tooltip-initial_efficiency_experienced_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-initial_efficiency_experienced_hire" placement="right">
                    Efficiency rate of a recently hired experienced Technician completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="initial_efficiency_experienced_hire"
                  v-model="initial_efficiency_experienced_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !initial_efficiency_experienced_hire && !clearedInputs, 'empty': !initial_efficiency_experienced_hire && clearedInputs, 'default': initial_efficiency_experienced_hire === originalValues.initial_efficiency_experienced_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !initial_efficiency_experienced_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="eff_ratio_at_dealership">Efficiency Ratio of an experienced Technician at dealership</label>
                  <font-awesome-icon id="tooltip-eff_ratio_at_dealership" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-eff_ratio_at_dealership" placement="right">
                    Efficiency rate of an experienced Technician completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="eff_ratio_at_dealership"
                  v-model="eff_ratio_at_dealership"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !eff_ratio_at_dealership && !clearedInputs, 'empty': !eff_ratio_at_dealership && clearedInputs, 'default': eff_ratio_at_dealership === originalValues.eff_ratio_at_dealership }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !eff_ratio_at_dealership"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Productivity</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="productivity_ratio_new_hire">Productivity Ratio for new hire</label>
                  <font-awesome-icon id="tooltip-productivity_ratio_new_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-productivity_ratio_new_hire" placement="right">
                    Percentage of time new Technicians spend working at their bay
                  </b-tooltip>
                </div>
                <input
                  id="productivity_ratio_new_hire"
                  v-model="productivity_ratio_new_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !productivity_ratio_new_hire && !clearedInputs, 'empty': !productivity_ratio_new_hire && clearedInputs, 'default': productivity_ratio_new_hire === originalValues.productivity_ratio_new_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !productivity_ratio_new_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="productivity_ratio_experienced_hire">Productivity Ratio for an experienced hire</label>
                  <font-awesome-icon id="tooltip-productivity_ratio_experienced_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-productivity_ratio_experienced_hire" placement="right">
                    Percentage of time a recently hired experienced Technician spends working at their bay
                  </b-tooltip>
                </div>
                <input
                  id="productivity_ratio_experienced_hire"
                  v-model="productivity_ratio_experienced_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !productivity_ratio_experienced_hire && !clearedInputs, 'empty': !productivity_ratio_experienced_hire && clearedInputs, 'default': productivity_ratio_experienced_hire === originalValues.productivity_ratio_experienced_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !productivity_ratio_experienced_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="productivity_ratio_at_dealership">Productivity Ratio for experienced Technician at dealership</label>
                  <font-awesome-icon id="tooltip-productivity_ratio_at_dealership" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-productivity_ratio_at_dealership" placement="right">
                    Percentage of time experienced Technicians spend working at their bay
                  </b-tooltip>
                </div>
                <input
                  id="productivity_ratio_at_dealership"
                  v-model="productivity_ratio_at_dealership"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !productivity_ratio_at_dealership && !clearedInputs, 'empty': !productivity_ratio_at_dealership && clearedInputs, 'default': productivity_ratio_at_dealership === originalValues.productivity_ratio_at_dealership }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !productivity_ratio_at_dealership"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Proficiency</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="proficiency_ratio_new_hire">Proficiency Ratio for new hire</label>
                  <font-awesome-icon id="tooltip-proficiency_ratio_new_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-proficiency_ratio_new_hire" placement="right">
                    Proficiency rate of new Technicians completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="proficiency_ratio_new_hire"
                  v-model="proficiency_ratio_new_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !proficiency_ratio_new_hire && !clearedInputs, 'empty': !proficiency_ratio_new_hire && clearedInputs, 'default': proficiency_ratio_new_hire === originalValues.proficiency_ratio_new_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !proficiency_ratio_new_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="proficiency_ratio_experienced_hire">Proficiency Ratio for an experienced hire</label>
                  <font-awesome-icon id="tooltip-proficiency_ratio_experienced_hire" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-proficiency_ratio_experienced_hire" placement="right">
                    Proficiency rate of a recently hired experienced Technician completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="proficiency_ratio_experienced_hire"
                  v-model="proficiency_ratio_experienced_hire"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !proficiency_ratio_experienced_hire && !clearedInputs, 'empty': !proficiency_ratio_experienced_hire && clearedInputs, 'default': proficiency_ratio_experienced_hire === originalValues.proficiency_ratio_experienced_hire }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !proficiency_ratio_experienced_hire"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="proficiency_ratio_dealership">Proficiency Ratio for experienced Technician at dealership</label>
                  <font-awesome-icon id="tooltip-proficiency_ratio_dealership" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-proficiency_ratio_dealership" placement="right">
                    Proficiency rate of an experienced Technician completing repair orders
                  </b-tooltip>
                </div>
                <input
                  id="proficiency_ratio_dealership"
                  v-model="proficiency_ratio_dealership"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !proficiency_ratio_dealership && !clearedInputs, 'empty': !proficiency_ratio_dealership && clearedInputs, 'default': proficiency_ratio_dealership === originalValues.proficiency_ratio_dealership }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !proficiency_ratio_dealership"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h2 class="section-header">Interview and Recruiting Costs</h2>
            <h3 class="input-header">Candidate Statistics</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="avg_number_candidates_interviewed">Average number of candidates interviewed per position</label>
<!--                  <font-awesome-icon id="tooltip-avg_number_candidates_interviewed" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-avg_number_candidates_interviewed" placement="right">-->
<!--                    Average number of candidates interviewed per position-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="avg_number_candidates_interviewed"
                  v-model="avg_number_candidates_interviewed"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !avg_number_candidates_interviewed && !clearedInputs, 'empty': !avg_number_candidates_interviewed && clearedInputs, 'default': avg_number_candidates_interviewed === originalValues.avg_number_candidates_interviewed }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !avg_number_candidates_interviewed"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Hiring Manager Statistics</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hiring_manager_salary">Hiring Manager salary</label>
                  <font-awesome-icon id="tooltip-hiring_manager_salary" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-hiring_manager_salary" placement="right">
                    Average yearly salary of hiring Manager
                  </b-tooltip>
                </div>
                <input
                  id="hiring_manager_salary"
                  v-model="hiring_manager_salary"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hiring_manager_salary && !clearedInputs, 'empty': !hiring_manager_salary && clearedInputs, 'default': hiring_manager_salary === originalValues.hiring_manager_salary }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hiring_manager_salary"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hiring_manager_daily_hours_worked">Hours worked per day</label>
                  <font-awesome-icon id="tooltip-hiring_manager_daily_hours_worked" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-hiring_manager_daily_hours_worked" placement="right">
                    Average number of hours worked daily
                  </b-tooltip>
                </div>
                <input
                  id="hiring_manager_daily_hours_worked"
                  v-model="hiring_manager_daily_hours_worked"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hiring_manager_daily_hours_worked && !clearedInputs, 'empty': !hiring_manager_daily_hours_worked && clearedInputs, 'default': hiring_manager_daily_hours_worked === originalValues.hiring_manager_daily_hours_worked }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hiring_manager_daily_hours_worked"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hiring_manager_days_worked_weekly">Days worked per week</label>
                  <font-awesome-icon id="tooltip-hiring_manager_days_worked_weekly" class="fa-fw" :icon="['fal', 'info-circle']"/>
                  <b-tooltip target="tooltip-hiring_manager_days_worked_weekly" placement="right">
                    Average number of days worked weekly
                  </b-tooltip>
                </div>
                <input
                  id="hiring_manager_days_worked_weekly"
                  v-model="hiring_manager_days_worked_weekly"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hiring_manager_days_worked_weekly && !clearedInputs, 'empty': !hiring_manager_days_worked_weekly && clearedInputs, 'default': hiring_manager_days_worked_weekly === originalValues.hiring_manager_days_worked_weekly }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hiring_manager_days_worked_weekly"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Interviewing Statistics</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hrs_per_interview_candidate">Hours per interview with candidate</label>
<!--                  <font-awesome-icon id="tooltip-hrs_per_interview_candidate" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-hrs_per_interview_candidate" placement="right">-->
<!--                    Average hours spent interviewing one candidate-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="hrs_per_interview_candidate"
                  v-model="hrs_per_interview_candidate"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hrs_per_interview_candidate && !clearedInputs, 'empty': !hrs_per_interview_candidate && clearedInputs, 'default': hrs_per_interview_candidate === originalValues.hrs_per_interview_candidate }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hrs_per_interview_candidate"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hrs_per_candidate_resume_review">Hours per candidate's resume review</label>
<!--                  <font-awesome-icon id="tooltip-hrs_per_candidate_resume_review" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-hrs_per_candidate_resume_review" placement="right">-->
<!--                    Average hours spent reviewing the resume of one candidate-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="hrs_per_candidate_resume_review"
                  v-model="hrs_per_candidate_resume_review"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hrs_per_candidate_resume_review && !clearedInputs, 'empty': !hrs_per_candidate_resume_review && clearedInputs, 'default': hrs_per_candidate_resume_review === originalValues.hrs_per_candidate_resume_review }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hrs_per_candidate_resume_review"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hrs_per_job_posting">Hours per job posting</label>
<!--                  <font-awesome-icon id="tooltip-hrs_per_job_posting" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-hrs_per_job_posting" placement="right">-->
<!--                    Average hours spent posting job ad per candidate-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="hrs_per_job_posting"
                  v-model="hrs_per_job_posting"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hrs_per_job_posting && !clearedInputs, 'empty': !hrs_per_job_posting && clearedInputs, 'default': hrs_per_job_posting === originalValues.hrs_per_job_posting }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hrs_per_job_posting"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="hrs_for_legal_paperwork_candidate">Hours for legal paperwork per candidate</label>
<!--                  <font-awesome-icon id="tooltip-hrs_for_legal_paperwork_candidate" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-hrs_for_legal_paperwork_candidate" placement="right">-->
<!--                    Average hours spent processing legal paperwork per candidate-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="hrs_for_legal_paperwork_candidate"
                  v-model="hrs_for_legal_paperwork_candidate"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !hrs_for_legal_paperwork_candidate && !clearedInputs, 'empty': !hrs_for_legal_paperwork_candidate && clearedInputs, 'default': hrs_for_legal_paperwork_candidate === originalValues.hrs_for_legal_paperwork_candidate }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !hrs_for_legal_paperwork_candidate"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Job Posting Statistics</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="job_post_monthly_cost_less_than_5">Short term job posting costs</label>
<!--                  <font-awesome-icon id="tooltip-job_post_monthly_cost_less_than_5" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-job_post_monthly_cost_less_than_5" placement="right">-->
<!--                    Average cost of running job posting for a single month-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="job_post_monthly_cost_less_than_5"
                  v-model="job_post_monthly_cost_less_than_5"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !job_post_monthly_cost_less_than_5 && !clearedInputs, 'empty': !job_post_monthly_cost_less_than_5 && clearedInputs, 'default': job_post_monthly_cost_less_than_5 === originalValues.job_post_monthly_cost_less_than_5 }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !job_post_monthly_cost_less_than_5"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="job_post_monthly_cost_more_than_5">Long term job posting costs</label>
<!--                  <font-awesome-icon id="tooltip-job_post_monthly_cost_more_than_5" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-job_post_monthly_cost_more_than_5" placement="right">-->
<!--                    Average cost of running job posting for more than 5 months (discounted price from bulk)-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="job_post_monthly_cost_more_than_5"
                  v-model="job_post_monthly_cost_more_than_5"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !job_post_monthly_cost_more_than_5 && !clearedInputs, 'empty': !job_post_monthly_cost_more_than_5 && clearedInputs, 'default': job_post_monthly_cost_more_than_5 === originalValues.job_post_monthly_cost_more_than_5 }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !job_post_monthly_cost_more_than_5"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

            <h3 class="input-header">Screening Statistics</h3>

            <div class="input-container">
              <div class="input">
                <div class="tooltip-container">
                  <label for="avg_cost_screen_candidate">Average cost to screen Candidate (Background check, drug screen, etc.)</label>
<!--                  <font-awesome-icon id="tooltip-avg_cost_screen_candidate" class="fa-fw" :icon="['fal', 'info-circle']"/>-->
<!--                  <b-tooltip target="tooltip-avg_cost_screen_candidate" placement="right">-->
<!--                    Average cost of screening a candidate-->
<!--                  </b-tooltip>-->
                </div>
                <input
                  id="avg_cost_screen_candidate"
                  v-model="avg_cost_screen_candidate"
                  type="number"
                  placeholder=""
                  :required="assumptions"
                  :class="{'error': !avg_cost_screen_candidate && !clearedInputs, 'empty': !avg_cost_screen_candidate && clearedInputs, 'default': avg_cost_screen_candidate === originalValues.avg_cost_screen_candidate }"
                  @focusout="$event.target.classList.toggle('focused')"
                  @keyup="iValid"
                  @focusin="iValid"
                >
              </div>
              <p class="error-msg" v-if="errors || !avg_cost_screen_candidate"><font-awesome-icon class="fa-fw" :icon="['fal', 'exclamation-triangle']" />Required.</p>
            </div>

          </b-card>
        </b-collapse>
      </div>

<!--        <b-button @click="calculate(selected)" type="button" variant="primary">Calculate</b-button>-->

<!--        <b-button class="chart-btn" @click="validateInputs">Chart Inputs</b-button>-->
<!--        <b-button class="clear-btn" @click="clearInputs">Clear Inputs</b-button>-->

<!--        <div class="footer-btns">-->
<!--          <b-button class="chart-btn" @click="validateInputs">Chart Inputs</b-button>-->
<!--          <b-button class="clear-btn" @click="clearInputs">Clear Inputs</b-button>-->
<!--        </div>-->


      </b-form>
  </div>
</template>

<script>
  export default {
    name: "Calculator",
    props: {
      selected: String,
    },
    components: {},
    data(){
      return {
        errors: false,
        assumptions: false,
        clearedInputs: false, // toggle when you've cleared the inputs
        debugFlag: false, // Toggle to show console tables and test buttons
        showcalcs: false,
        turnover_rate: 0, // calculated NOW
        new_hire: 1,
        experienced_hire: 0,
        // remaining_allocation: null, // defaults 0
        vacancy_days: 22,
        door_rate: 115,
        effective_labor_rate_toggle: false,
        effective_labor_rate: null, // toggle this
        months_equiv_efficiency: 12,
        months_equiv_efficiency_experienced: 6,
        avg_time_until_full_prod: 11, // this value is calculated on submit
        hrs_worked_daily: 8,
        days_worked_weekly: 5.5,
        weeks_worked_yearly: 50,
        percent_rev_labor: 50,
        percent_rev_parts: 50,
        labor_profit_margin: 70,
        parts_profit_margin: 40,
        initial_efficiency_new_hire: 70,
        initial_efficiency_experienced_hire: 85,
        eff_ratio_at_dealership: 115,
        productivity_ratio_new_hire: 85,
        productivity_ratio_experienced_hire: 85,
        productivity_ratio_at_dealership: 85,
        proficiency_ratio_new_hire: null, //calculated
        proficiency_ratio_experienced_hire: null, // calculated
        proficiency_ratio_dealership: null, // calculate
        avg_number_candidates_interviewed: 5,
        hiring_manager_salary: 75000,
        hiring_manager_daily_hours_worked: 8,
        hiring_manager_days_worked_weekly: 5,
        hrs_per_interview_candidate: 1,
        hrs_per_candidate_resume_review: 1,
        hrs_per_job_posting: 0.4,
        hrs_for_legal_paperwork_candidate: 1,
        job_post_monthly_cost_less_than_5: 300,
        job_post_monthly_cost_more_than_5: 250,
        avg_cost_screen_candidate: 150,

        results: false,

        calculateType: 0, // 0 => Revenue, 1 => Profit
        calculations: {
          profit: {
            newTechnician: null,
            experiencedTechnician: null,
            daily: null,
            total: null,
          },
          revenue: {
            newTechnician: null,
            experiencedTechnician: null,
            daily: null,
            total: null,
          },
        },
        datacollection: null, // line example
        recruitingCosts: null, // Pie
        totalInterviewingRecruitingCost: null, // total for graphs
        vacancyCosts: null, // Bar
        vacancyCostLoss: null, // total for bar graph
        revenueLost: null, // Bar graphs
        totalCostOfTurnover: null, // Bar graph
        lostProductionCosts: null, // Bar Graph,
        instructionToggle: ['revenue', 'profit'],
        selectedToggle: 'revenue',
        originalValues: null,
      }
    },
    created() {
      // Initialize inputs
      this.turnover_rate = this.new_hire; // defaults to 1 to match excel
      this.calculateProficiencies();
      // Make a copy of $data after all the calculations have been completed
      this.copyOriginalInputValues()
      this.datacollection = {
        labels: [this.getRandomInt(), this.getRandomInt()],
        datasets: [
          {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }, {
            label: 'Data One',
            backgroundColor: '#f87979',
            data: [this.getRandomInt(), this.getRandomInt()]
          }
        ]
      }
    },
    methods: {
      copyOriginalInputValues() {
        // Use this to show if input matches original value
        this.originalValues = { ...this.$data };
        console.log('ORIGINAL VALUES', this.originalValues);
      },
      clearInputs() {
          this.new_hire = null;
          this.experienced_hire = null;
          // remaining_allocation: null, // defaults 0
          this.vacancy_days = null;
          this.door_rate = null;
          this.effective_labor_rate_toggle = false,
          this.effective_labor_rate = null,
          this.months_equiv_efficiency = null;
          this.months_equiv_efficiency_experienced = null;
          this.avg_time_until_full_prod = null;
          // Default metrics
          // this.hrs_worked_daily = null;
          // this.days_worked_weekly = null;
          // this.weeks_worked_yearly = null;
          // this.percent_rev_labor = null;
          // this.percent_rev_parts = null;
          // this.labor_profit_margin = null;
          // this.parts_profit_margin = null;
          // this.initial_efficiency_new_hire = null;
          // this.initial_efficiency_experienced_hire = null;
          // this.eff_ratio_at_dealership = null;
          // this.productivity_ratio_new_hire = null;
          // this.productivity_ratio_experienced_hire = null;
          // this.productivity_ratio_at_dealership = null;
          // this.proficiency_ratio_new_hire = null;
          // this.proficiency_ratio_experienced_hire = null;
          // this.proficiency_ratio_dealership = null;
          // this.avg_number_candidates_interviewed = null;
          // this.hiring_manager_salary = null;
          // this.hiring_manager_daily_hours_worked = null;
          // this.hiring_manager_days_worked_weekly = null;
          // this.hrs_per_interview_candidate = null;
          // this.hrs_per_candidate_resume_review = null;
          // this.hrs_per_job_posting = null;
          // this.hrs_for_legal_paperwork_candidate = null;
          // this.job_post_monthly_cost_less_than_5 = null;
          // this.job_post_monthly_cost_more_than_5 = null;
          // this.avg_cost_screen_candidate = null;

          // toggle clear inputs to show dashed borders
        this.clearedInputs = true;
        this.$emit('submitted', false);
      },
      isValid(input) {
        console.log('input', input);
        let valid = false;
        if (input !== null && input !== '') {
          valid = true;
        }
        return valid;
      },
      validateInputs() {
        // check the original ones first, then check if the assumptions are toggled
        const inputs = [
          this.new_hire,
          this.experienced_hire,
          this.vacancy_days,
          this.door_rate,
          this.months_equiv_efficiency,
          this.months_equiv_efficiency_experienced,
          this.avg_time_until_full_prod
        ];

          if (this.effective_labor_rate_toggle) {
            inputs.push(this.effective_labor_rate);
          }

        let assumptions;

        if (this.assumptions) {
          assumptions = [
            this.hrs_worked_daily,
            this.days_worked_weekly,
            this.weeks_worked_yearly,
            this.percent_rev_labor,
            this.percent_rev_parts,
            this.labor_profit_margin,
            this.parts_profit_margin,
            this.initial_efficiency_new_hire,
            this.initial_efficiency_experienced_hire,
            this.eff_ratio_at_dealership,
            this.productivity_ratio_new_hire,
            this.productivity_ratio_experienced_hire,
            this.productivity_ratio_at_dealership,
            this.proficiency_ratio_new_hire,
            this.proficiency_ratio_experienced_hire,
            this.proficiency_ratio_dealership,
            this.avg_number_candidates_interviewed,
            this.hiring_manager_salary,
            this.hiring_manager_daily_hours_worked,
            this.hiring_manager_days_worked_weekly,
            this.hrs_per_interview_candidate,
            this.hrs_per_candidate_resume_review,
            this.hrs_per_job_posting,
            this.hrs_for_legal_paperwork_candidate,
            this.job_post_monthly_cost_less_than_5,
            this.job_post_monthly_cost_more_than_5,
            this.avg_cost_screen_candidate
          ];

          inputs.push(assumptions);
          inputs.flat();
        }

        console.log('inputs', inputs);

        let errors = [];

        for (let i = 0; i < inputs.length; i++) {
          if (!this.isValid(inputs[i])) {
            // this.errors = true;
            errors.push(inputs[i])
          }
        }


        if (errors.length <= 0) {
          this.calculate(this.selected);
        }
      },
      submit(e) {
        e.preventDefault();
        // Toggles type of calculation
        this.calculate(this.selectedToggle);
      },
      convertPercent(percent) {
        return percent / 100;
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      },
      calculateProficiencies() {
        this.proficiency_ratio_new_hire = Math.ceil((this.convertPercent(this.initial_efficiency_new_hire) * this.convertPercent(this.productivity_ratio_new_hire)) * 100) ;
        this.proficiency_ratio_experienced_hire = Math.ceil((this.convertPercent(this.initial_efficiency_experienced_hire) * this.convertPercent(this.productivity_ratio_experienced_hire)) * 100) ;
        this.proficiency_ratio_dealership = Math.ceil((this.convertPercent(this.eff_ratio_at_dealership) * this.convertPercent(this.productivity_ratio_at_dealership)) * 100) ;
      },
      newHireCheck() {
        if (this.new_hire < 1) {
          // reset to 0
          this.new_hire = null;
        }
      },
      iValid(e) {
        console.log('CHECK NOW', e.target.value)
        console.log('e', e.target.classList);
        if (e && e.target && e.target.value) {
          e.target.classList.remove('error');
          e.target.classList.add('focused');
          if (!isNaN(parseInt(e.target.value))) {
            console.log('here we go');
            e.target.classList.add('valid');
            e.target.classList.remove('invalid');
          } else {
            console.log('else')
            e.target.classList.add('invalid');
            e.target.classList.remove('valid');
          }
        }
      },
      experiencedHireCheck() {
        if (!this.experienced_hire) {
          // reset to 0
          this.experienced_hire = 0;
        }
      },
      calculate(selectedToggle = 'revenue') {
        this.results = true;

        // Figure average time until full production
        if (this.new_hire && this.experienced_hire) {
          this.avg_time_until_full_prod = ((parseInt(this.new_hire) * this.months_equiv_efficiency) + (parseInt(this.experienced_hire) * this.months_equiv_efficiency_experienced)) / (parseInt(this.new_hire) + parseInt(this.experienced_hire));
        } else {
          this.avg_time_until_full_prod = 12;
        }
        console.log('this.avg_time_until_full_prod', this.avg_time_until_full_prod);

        if (selectedToggle === 'revenue') {
          this.costOfTurnoverRevenue();
          this.calculateTotalInterviewingRecruitingCosts();
          this.createVacancyCostsRevenue();
          this.calculateTotalLostProductionCostFromTechnicianTurnoverRevenue();
        } else if (selectedToggle === 'profit') {
          console.log('PROFIT');
          this.costOfTurnoverProfit();
          this.calculateTotalInterviewingRecruitingCosts();
          this.createVacancyCostsProfit();
          this.calculateTotalLostProductionCostFromTechnicianTurnoverProfit();
        } else {
          this.calculate('revenue');
        }

        // Update selected toggle
        this.selectedToggle = selectedToggle;

        // Prepare data to emit back to dashboard
        const calculations = {
          datacollection: this.datacollection,
          recruitingCosts: this.recruitingCosts,
          totalInterviewingRecruitingCost: this.totalInterviewingRecruitingCost,
          vacancyCosts: this.vacancyCosts,
          vacancyCostLoss: this.vacancyCostLoss,
          revenueLost: this.revenueLost,
          totalCostOfTurnover: this.totalCostOfTurnover,
          lostProductionCosts: this.lostProductionCosts
        }

        this.$emit('calculations', calculations);
        this.$emit('submitted', true);
        this.$emit('closeModal');
      },
      createRecruitingCostChart(hiring, jobPosting, jobScreening) {
        this.recruitingCosts = {
          labels: ['Hiring Manager Cost Per Position', 'Total Cost of Job Posting', 'Cost of Screening'],
          datasets: [
            {
              label: 'Pie Chart',
              data: [hiring, jobPosting, jobScreening],
              backgroundColor: [
                '#00095b', '#6e6e6e', '#1700f4'
              ]
            }
          ]
        }
      },
      createVacancyCostsRevenue() {
        const laborLosses = this.calculations.revenue.total;
        const experiencedTechnician = this.calculations.revenue.experiencedTechnician;
        const labor = this.calculations.revenue.labor;
        const parts = this.calculations.revenue.parts;
        const percentOfLabor = ((experiencedTechnician - labor) / experiencedTechnician) * 100;
        const percentOfPart = ((experiencedTechnician - parts) / experiencedTechnician) * 100;

        this.vacancyCosts = {
          labels: ['Weekly', 'Total'],
          datasets: [{
            label: 'Labor Losses',
            data: [(laborLosses / 4) * this.convertPercent(percentOfLabor) , laborLosses * this.convertPercent(percentOfLabor)],
            backgroundColor: '#00095b'
          }, {
            label: 'Parts Losses',
            data: [(laborLosses / 4) * this.convertPercent(percentOfPart), laborLosses * this.convertPercent(percentOfPart)],
            backgroundColor: '#6e6e6e'
          },]
        };

        this.vacancyCostLoss = laborLosses;
      },
      createVacancyCostsProfit() {
        const laborLosses = this.calculations.profit.total;
        const experiencedTechnician = this.calculations.profit.experiencedTechnician;
        const labor = this.calculations.profit.labor;
        const parts = this.calculations.profit.parts;
        const percentOfLabor = ((experiencedTechnician - labor) / experiencedTechnician) * 100;
        const percentOfPart = ((experiencedTechnician - parts) / experiencedTechnician) * 100;

        this.vacancyCosts = {
          labels: ['Weekly', 'Total'],
          datasets: [{
            label: 'Labor Losses',
            data: [(laborLosses / 4) * this.convertPercent(percentOfLabor) , laborLosses * this.convertPercent(percentOfLabor)],
            backgroundColor: '#00095b'
          }, {
            label: 'Parts Losses',
            data: [(laborLosses / 4) * this.convertPercent(percentOfPart), laborLosses * this.convertPercent(percentOfPart)],
            backgroundColor: '#6e6e6e'
          },]
        }

        this.vacancyCostLoss = laborLosses;
      },
      // VACANCY COSTS
      // Profit Loss
      costOfTurnoverProfit() {

        // =CHOOSE(VLOOKUP(Input!$B$29,Reference!$A$6:$B$7,2,FALSE),
        // Input!$C$44*Input!$C$30*Input!$C$27*Input!$C$25*(2*Input!C$49),
        // (Input!$C$44*Input!$C$31*(2*Input!C$49)))

        // Check if it's door rate or labor effective labor rate
        //  hrs_worked_daily * door_rate OR effective_rate * average_productivity(new hires) * average_efficiency(newhires) 8 (2 * percent revenue labor)
        // hrs_worked_daily *


        // We need to calculate the hidden input percentages of both EFFICIENCY && PRODUCTIVITY (c25 , c27)
        // =IFERROR((($C$19*$C$56)+($C$20*$C$57))/($C$19+$C$20),0)
        let average_efficiency;

        if (this.new_hire && this.experienced_hire) {
          average_efficiency = ((this.new_hire * this.convertPercent(this.initial_efficiency_new_hire)) + (this.experienced_hire * this.convertPercent(this.initial_efficiency_experienced_hire))) / (parseInt(this.new_hire) + parseInt(this.experienced_hire));
        } else {
          average_efficiency = this.convertPercent(this.initial_efficiency_new_hire);
        }

        // const average_efficiency = ((this.new_hire * this.convertPercent(this.initial_efficiency_new_hire)) + (this.experienced_hire * this.convertPercent(this.initial_efficiency_experienced_hire))) / (parseInt(this.new_hire) + parseInt(this.experienced_hire));
        console.log('average_efficiency', average_efficiency);

        // New Technicians
        let newTechDailyLaborProfit;
        let newTechPartsProfit;
        let newTechDailyProfit;

        // One Year Technician
        let experiencedDailyLaborProfit;
        let experiencedPartsProfit;
        let experiencedDailyProfit;


        if (!this.effective_labor_rate_toggle) {
          newTechDailyLaborProfit = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_new_hire) * average_efficiency * (this.convertPercent(this.percent_rev_labor) * 2) * this.convertPercent(this.labor_profit_margin);
          newTechPartsProfit = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_new_hire) * average_efficiency * (this.convertPercent(this.percent_rev_labor) * 2) * this.convertPercent(this.parts_profit_margin);
          newTechDailyProfit = newTechDailyLaborProfit + newTechPartsProfit;

          experiencedDailyLaborProfit = (this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_experienced_hire) * this.convertPercent(this.eff_ratio_at_dealership)) * (this.convertPercent(this.percent_rev_labor) * 2) * this.convertPercent(this.labor_profit_margin);
          experiencedPartsProfit = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_at_dealership) * this.convertPercent(this.eff_ratio_at_dealership) * (this.convertPercent(this.percent_rev_parts) * 2) * this.convertPercent(this.parts_profit_margin);
          experiencedDailyProfit = experiencedDailyLaborProfit + experiencedPartsProfit;
        } else {
          console.log('Profit ELSE')
          newTechDailyLaborProfit = this.hrs_worked_daily * this.effective_labor_rate * (this.convertPercent(this.percent_rev_labor) * 2) * this.convertPercent(this.labor_profit_margin);
          newTechPartsProfit = this.hrs_worked_daily * this.effective_labor_rate  * (this.convertPercent(this.percent_rev_parts) * 2) * this.convertPercent(this.parts_profit_margin);
          newTechDailyProfit = newTechDailyLaborProfit + newTechPartsProfit;

          console.log('newTechDailyLaborProfit', newTechDailyLaborProfit);
          console.log('newTechPartsProfit', newTechPartsProfit);
          console.log('newTechDailyProfit', newTechDailyProfit);

          experiencedDailyLaborProfit = this.hrs_worked_daily * this.door_rate * (this.convertPercent(this.percent_rev_labor) * 2) * this.convertPercent(this.labor_profit_margin);
          experiencedPartsProfit = (this.hrs_worked_daily * this.door_rate * ((this.convertPercent(this.percent_rev_parts) * 2)) * this.convertPercent(this.parts_profit_margin));
          experiencedDailyProfit = experiencedDailyLaborProfit + experiencedPartsProfit;
          console.log('experiencedDailyLaborProfit', experiencedDailyLaborProfit);
          console.log('experiencedPartsProfit', experiencedPartsProfit);
          console.log('experiencedDailyProfit', experiencedDailyProfit);
        }


        // =CHOOSE(VLOOKUP(Input!$B$28,Reference!$A$6:$B$7,2,FALSE),
        // ((Input!$C$44*Input!$C$30*Input!$C$62*Input!$C$58)*(2*Input!$C$49))*Input!$C$52,
        // (Input!$C$44*Input!$C$30*(2*Input!$C$49)*Input!$C$52))
        // c44 c30 c62 c58

        console.log('experiencedDailyLaborProfit', experiencedDailyLaborProfit);
        // Daily Total
        const dailyProfitLoss = experiencedDailyProfit - newTechDailyProfit;

        // Total
        const totalVacancyProfitLoss = this.vacancy_days * experiencedDailyProfit * this.turnover_rate;
        console.log('totalVacancyProfitLoss', totalVacancyProfitLoss);

        // Set totals
        this.calculations.profit.labor = experiencedDailyLaborProfit;
        this.calculations.profit.parts = experiencedPartsProfit ;
        this.calculations.profit.newTechnician = newTechDailyProfit;
        this.calculations.profit.experiencedTechnician = experiencedDailyProfit;
        this.calculations.profit.daily = dailyProfitLoss;
        this.calculations.profit.total = totalVacancyProfitLoss;

        if (this.debugFlag) {
          console.log('---------- costOfTurnoverProfit  ----------');
          console.log('New Technician ---');
          console.table([newTechDailyLaborProfit, newTechPartsProfit, newTechDailyProfit ]);
          console.log('One Year Technician ---');
          console.table([experiencedDailyLaborProfit, experiencedPartsProfit, experiencedDailyProfit]);
          console.log('dailyProfitLoss', dailyProfitLoss);
          console.log('<<< TOTAL >>>')
          console.log('totalVacancyProfitLoss', totalVacancyProfitLoss);
        }

      },
      // Revenue Lost
      costOfTurnoverRevenue() {
        let average_efficiency;

        if (this.new_hire && this.experienced_hire) {
          average_efficiency = ((this.new_hire * this.convertPercent(this.initial_efficiency_new_hire)) + (this.experienced_hire * this.convertPercent(this.initial_efficiency_experienced_hire))) / (parseInt(this.new_hire) + parseInt(this.experienced_hire));
        } else {
          average_efficiency = this.convertPercent(this.initial_efficiency_new_hire);
        }

        // const average_efficiency = ((this.new_hire * this.convertPercent(this.initial_efficiency_new_hire)) + (this.experienced_hire * this.convertPercent(this.initial_efficiency_experienced_hire))) / (parseInt(this.new_hire) + parseInt(this.experienced_hire));
        // New Technicians
        let newTechaverageDailyLaborRevenue;
        let newTechaverageDailyPartsRevenue;
        let newTechDailyRevenueLoss;

        // One Year Technician
        let ExperiencedAverageDailyLaborRevenue;
        let ExperiencedAverageDailyPartsRevenue;
        let ExperiencedTechDailyRevenueLoss;

        if (!this.effective_labor_rate_toggle) {
          // New Technicians
          newTechaverageDailyLaborRevenue = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_new_hire) * average_efficiency * (this.convertPercent(this.percent_rev_labor) * 2);
          newTechaverageDailyPartsRevenue = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_new_hire) * average_efficiency * (this.convertPercent(this.percent_rev_parts) * 2);
          newTechDailyRevenueLoss = newTechaverageDailyLaborRevenue + newTechaverageDailyPartsRevenue;

          // One Year Technician
          ExperiencedAverageDailyLaborRevenue = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_at_dealership) * this.convertPercent(this.eff_ratio_at_dealership) * (this.convertPercent(this.percent_rev_labor) * 2);
          ExperiencedAverageDailyPartsRevenue = this.hrs_worked_daily * this.door_rate * this.convertPercent(this.productivity_ratio_at_dealership) * this.convertPercent(this.eff_ratio_at_dealership) * (this.convertPercent(this.percent_rev_parts) * 2);
          ExperiencedTechDailyRevenueLoss = ExperiencedAverageDailyLaborRevenue +  ExperiencedAverageDailyPartsRevenue;
        } else {

          newTechaverageDailyLaborRevenue = this.hrs_worked_daily * this.effective_labor_rate * (this.convertPercent(this.percent_rev_labor) * 2);
          newTechaverageDailyPartsRevenue = this.hrs_worked_daily * this.effective_labor_rate *  (this.convertPercent(this.percent_rev_parts) * 2);
          newTechDailyRevenueLoss = newTechaverageDailyLaborRevenue + newTechaverageDailyPartsRevenue;
          console.log('ELSEEE &&&&&&')
          console.log('newTechaverageDailyLaborRevenue', newTechaverageDailyLaborRevenue);
          console.log('newTechaverageDailyPartsRevenue', newTechaverageDailyPartsRevenue);
          console.log('newTechDailyRevenueLoss', newTechDailyRevenueLoss);
          // One Year Technician
          ExperiencedAverageDailyLaborRevenue = this.hrs_worked_daily * this.door_rate * (this.convertPercent(this.percent_rev_labor) * 2);
          ExperiencedAverageDailyPartsRevenue = this.hrs_worked_daily * this.door_rate * (this.convertPercent(this.percent_rev_parts) * 2);
          ExperiencedTechDailyRevenueLoss = ExperiencedAverageDailyLaborRevenue +  ExperiencedAverageDailyPartsRevenue;
          console.log('ExperiencedAverageDailyLaborRevenue', ExperiencedAverageDailyLaborRevenue);
          console.log('ExperiencedAverageDailyPartsRevenue', ExperiencedAverageDailyPartsRevenue);
          console.log('ExperiencedTechDailyRevenueLoss', ExperiencedTechDailyRevenueLoss);
        }

        // Daily Total
        const dailyRevenueLoss = ExperiencedTechDailyRevenueLoss - newTechDailyRevenueLoss;

        // Total
        const totalVacancyRevenueLoss = this.vacancy_days * ExperiencedTechDailyRevenueLoss * this.turnover_rate;

        // Set totals
        this.calculations.revenue.labor = ExperiencedAverageDailyLaborRevenue;
        this.calculations.revenue.parts = ExperiencedAverageDailyPartsRevenue ;
        this.calculations.revenue.newTechnician = newTechDailyRevenueLoss;
        this.calculations.revenue.experiencedTechnician = ExperiencedTechDailyRevenueLoss;
        this.calculations.revenue.daily= dailyRevenueLoss;
        this.calculations.revenue.total = totalVacancyRevenueLoss;

        if (this.debugFlag) {
          console.log('---------- costOfTurnoverRevenue ----------');
          console.log('New Technician ---');
          console.table([newTechaverageDailyLaborRevenue, newTechaverageDailyPartsRevenue, newTechDailyRevenueLoss ]);
          console.log('One Year Technician ---');
          console.table([ExperiencedAverageDailyLaborRevenue, ExperiencedAverageDailyPartsRevenue, ExperiencedTechDailyRevenueLoss ])
          console.log('dailyRevenueLoss', dailyRevenueLoss);
          console.log('<<< TOTAL >>>')
          console.log('totalVacancyRevenueLoss', totalVacancyRevenueLoss);
        }
      },

      // INTERVIEWING & RECRUITING COSTS
      calculateHiringManagerCosts() {
        // c71 / (c72 * c73 * 52)
        // Salary / (hours * week * weeks in a year)
        const hiringManagerSalary = this.hiring_manager_salary / (this.hiring_manager_daily_hours_worked * this.hiring_manager_days_worked_weekly * 52);
        const hiringManagerHoursSpentRecruitingPerCandidate = this.hrs_per_interview_candidate + this.hrs_per_candidate_resume_review + this.hrs_per_job_posting + this.hrs_for_legal_paperwork_candidate;
        const numberOfCandidatesInterviewedPerPosition = this.avg_number_candidates_interviewed;
        const numberOfPositionsNeededToFill = this.turnover_rate;

        // Multiple the salary, hours, candidates, and positions
        const hiringManagerCostPerPosition = hiringManagerSalary * hiringManagerHoursSpentRecruitingPerCandidate * numberOfCandidatesInterviewedPerPosition * numberOfPositionsNeededToFill;

        // const
        if (this.debugFlag) {
          console.log('---------- calculateHiringManagerCosts ----------');
          console.table([hiringManagerSalary, hiringManagerHoursSpentRecruitingPerCandidate]);
          console.log('Hiring manager cost per position: ', hiringManagerCostPerPosition);

        }

        return hiringManagerCostPerPosition;
      },
      calculateJobPostingCost() {
        const vacancyDays = parseInt(this.vacancy_days);
        const positionsToFill = parseInt(this.turnover_rate);
        const totalVacancyDays = vacancyDays * positionsToFill;
        const vacancyMonths = Math.ceil(totalVacancyDays / 30);
        console.log('vacancyMonths', vacancyMonths);
        let monthlyCostOfJobPosting;

        if (vacancyMonths < 150) {
          monthlyCostOfJobPosting = this.job_post_monthly_cost_less_than_5;
        } else {
          monthlyCostOfJobPosting = this.job_post_monthly_cost_more_than_5;
        }

        const totalCostOfPosition = vacancyMonths * monthlyCostOfJobPosting;
        console.log('<<<<totalCostOfPosition>>>', totalCostOfPosition);

        if (this.debugFlag) {
          console.log('---------- calculateJobPostingCost ----------');
          console.table([vacancyDays, positionsToFill, monthlyCostOfJobPosting]);
          console.log('totalCostOfPosition', totalCostOfPosition);
        }

        return totalCostOfPosition;
      },
      calculateJobScreeningCost() {
        const costOfScreeningPerCandidate = this.avg_cost_screen_candidate;
        const numberOfCandidatesInterviewedPerPosition = this.avg_number_candidates_interviewed;
        const positionsToFill = this.turnover_rate;

        const costOfScreening = costOfScreeningPerCandidate * numberOfCandidatesInterviewedPerPosition * positionsToFill;

        if (this.debugFlag) {
          console.log('---------- calculateJobScreeningCost ----------');
          console.table([costOfScreeningPerCandidate, numberOfCandidatesInterviewedPerPosition, positionsToFill]);
          console.log('costOfScreening', costOfScreening);
        }

        return costOfScreening;
      },
      calculateTotalInterviewingRecruitingCosts() {
        const hiringManagerCost = this.calculateHiringManagerCosts();
        const jobPostingCost = this.calculateJobPostingCost();
        const jobScreeningCost = this.calculateJobScreeningCost();

        this.totalInterviewingRecruitingCost = hiringManagerCost + jobPostingCost + jobScreeningCost;

        this.createRecruitingCostChart(hiringManagerCost, jobPostingCost, jobScreeningCost);
        if (this.debugFlag) {
          console.log('---------- calculateTotalInterviewingRecruitingCosts ----------');
          console.table([hiringManagerCost, jobPostingCost, jobScreeningCost]);
          console.log('this.totalInterviewingRecruitingCost', this.totalInterviewingRecruitingCost);
        }
      },
      testGrowthRates() {
        const newTechStatic = [
          6690.44,
          26149.87,
          27253,
          28404,
          29604,
          30855,
          32158,
          33516,
          34932,
          36407,
          37945,
          39548
        ];

        let differences = [];
        let diffs = newTechStatic.slice(1).map((x,i)=> x-newTechStatic[i]);

        diffs.forEach((x,i) => {
          differences.push(x);
          console.log(
            `# increased by ${x}` +
            `increased by ${(x / newTechStatic[i]) * 100}`
          )
        });
        console.log('differences', differences);
        // Calculate Revenue ($F$49×(1+$H$63)^($F52−$D$48))
      },
      // LOST PRODUCTION COSTS
      calculateTotalLostProductionCostFromTechnicianTurnoverRevenue() {
        if (this.debugFlag) {
          this.testGrowthRates();
        }

        // Calculate how experienced tech
        const months = 12;
        const experiencedTechMonthly = this.days_worked_weekly * this.calculations.revenue.experiencedTechnician * ( this.weeks_worked_yearly / months) * this.turnover_rate;
        const newTechMonthly = this.days_worked_weekly * this.calculations.revenue.newTechnician * ( this.weeks_worked_yearly / months) * this.turnover_rate;
        console.log('experiencedTechMonthly', experiencedTechMonthly);
        console.log('newTechMonthly', newTechMonthly);

        // Calculating Experienced Technician Cost for 12 months
        let rollingRevenueForExperiencedTech = [];

        for (let i = 0; i < months; i++) {
          let calc;
          if (rollingRevenueForExperiencedTech.length === 0) {
            calc = experiencedTechMonthly;
          } else {
            calc = rollingRevenueForExperiencedTech[i - 1] + experiencedTechMonthly;
          }
          rollingRevenueForExperiencedTech.push(calc)
        }

        console.log('rollingRevenueForExperiencedTech', rollingRevenueForExperiencedTech);

        // Vacancy Months per position (doesn't have an input so use turnover_rate)
        // const growthRate = 0.04223388250834771;
        let growthRate;
        if (this.avg_time_until_full_prod <= 0) {
          growthRate = 0
        } else {

          this.costOfTurnoverProfit();
          // growthRate = Math.pow(parseInt(this.calculations.revenue.experiencedTechnician) / parseInt(this.calculations.revenue.newTechnician), (1 / parseInt(this.avg_time_until_full_prod))) - 1; // dynamic
          growthRate = parseFloat((Math.pow(parseFloat(this.calculations.profit.experiencedTechnician.toFixed(2)) / parseFloat(this.calculations.profit.newTechnician.toFixed(2)), (1 / parseInt(this.avg_time_until_full_prod))) - 1)); // dynamic
          // growthRate = parseFloat((Math.pow(989.23 / 666.66, (1 / 9)) - 1).toFixed(7));
          // growthRate = 0.044826106;// from excel
          console.log('this.calculations.profit.experiencedTechnician.toFixed(2)', this.calculations.profit.experiencedTechnician.toFixed(2));
          console.log('this.calculations.profit.newTechnician.toFixed(2)', this.calculations.profit.newTechnician.toFixed(2));
          console.log('growthRate ', growthRate )
          console.log('REAL GROWTH RATE', Math.pow(989.23 / 666.66, (1 / 9)) - 1)
        }

        let newHireWeeklyAmounts = [];
        const vacancyDays = parseInt(this.vacancy_days);
        const positionsToFill = parseInt(this.turnover_rate);
        const totalVacancyDays = vacancyDays * positionsToFill;
        const vacancyMonths = Math.ceil(totalVacancyDays / 30);

        // IF STARTS
        let h51; // experiencedTechMonthly

        // console.log('First IF', Math.pow(this.weeks_worked_yearly * (1 + growthRate), (this.days_worked_weekly - vacancyMonths)));
        const firstIF = Math.pow(this.weeks_worked_yearly * (1 + growthRate), (this.days_worked_weekly - vacancyMonths));

        // IF($F$49*(1+$H$63)^($F51-$D$48)>$H$51,$H$51,
        if (firstIF > experiencedTechMonthly) {
          h51 = firstIF;
          console.log('FIRST IF', h51);
        }

        const vacancyMonthsPerPosition = Math.ceil(vacancyMonths / this.turnover_rate);
        const interviewingStatistics = this.hrs_per_interview_candidate + this.hrs_per_candidate_resume_review + this.hrs_per_job_posting + this.hrs_for_legal_paperwork_candidate;
        console.log('interviewingStatistics', interviewingStatistics);
        // ADD these
        // hrs_per_interview_candidate: 1,
        //   hrs_per_candidate_resume_review: 1,
        //   hrs_per_job_posting: 0.4,
        //   hrs_for_legal_paperwork_candidate: 1,

        // IF($F51=$D$48,
        // ((($D$48*30)-$D$35)/30)*$F$49,
        if (1 === vacancyMonthsPerPosition) {
          // h51 = ((((vacancyMonthsPerPosition * 30) * interviewingStatistics) - this.vacancy_days) / 30) * this.weeks_worked_yearly;
          h51 = (((vacancyMonthsPerPosition * 30) - this.vacancy_days) / 30) * newTechMonthly;
          console.log('second IF', h51);
        }
        // IF($F51>$D$48,
        // $F$49*(1+$H$63)^($F51-$D$48),
        if (1 > vacancyMonthsPerPosition) {
          h51 =
            console.log('third IF', h51);
        }
        // IF($F51<$D$48,0,0))))
        if (1 < vacancyMonthsPerPosition) {
          h51 = 0;
          console.log('fourth IF', h51);
        }

        // IF ENDS
        console.log('H51', h51);

        // Now that we have 51, use this as our starting number
        // =IF($F$49*(1+$H$63)^($F52-$D$48)>$H$51,$H$51,IF($F52=$D$48,((($D$48*30)-$D$35)/30)*$F$49,IF($F52>$D$48,$F$49*(1+$H$63)^($F52-$D$48),IF($F52<$D$48,0,0))))
        let newTechWeeklyStart = h51;

        // Calculating Experienced Technician Cost for 12 months
        for (let i = 0; i < months; i++) {
          let calc;

          // =IF($F$49*(1+$H$63)^($F52-$D$48)>$H$51,$H$51,
          // IF($F52=$D$48,((($D$48*30)-$D$35)/30)*$F$49,
          // IF($F52>$D$48,$F$49*(1+$H$63)^($F52-$D$48),
          // IF($F52<$D$48,0,0))))

          if (newHireWeeklyAmounts.length === 0) {
            calc = newTechWeeklyStart;
          } else if (newHireWeeklyAmounts.length === 1) {
            calc = Math.pow((newTechMonthly * (1 + growthRate)), ((i + 1) - vacancyMonthsPerPosition));
          } else {
            calc = newHireWeeklyAmounts[i - 1] + (newHireWeeklyAmounts[i - 1] * growthRate) ;

            if (calc >= experiencedTechMonthly) {
              calc = experiencedTechMonthly;
            }
          }

          newHireWeeklyAmounts.push(calc)
        }
        console.table(newHireWeeklyAmounts);
        console.table(rollingRevenueForExperiencedTech);
        // Matching first IF statement in EXCEL
        // if (newTechWeeklyStart === this.turnover_rate) {
        //   newTechWeeklyStart = (((this.turnover_rate * 30) - this.vacancy_days) / 30) * newTechMonthly;
        //
        //   // Calculating Experienced Technician Cost for 12 months
        //   for (let i = 0; i < months; i++) {
        //     let calc;
        //     if (newHireWeeklyAmounts.length === 0) {
        //       calc = newTechWeeklyStart;
        //     } else if (newHireWeeklyAmounts.length === 1) {
        //       calc = Math.pow((newTechMonthly * (1 + growthRate)), (2 - this.turnover_rate));
        //     } else {
        //       calc = newHireWeeklyAmounts[i - 1] + (newHireWeeklyAmounts[i - 1]  * growthRate) ;
        //     }
        //
        //     newHireWeeklyAmounts.push(calc)
        //   }
        //
        //   console.table(newHireWeeklyAmounts);
        //   console.table(rollingRevenueForExperiencedTech);
        // }

        // console.log('tesss', newTechWeeklyStart);
        // console.log('newTechWeeklyStart', newTechWeeklyStart);
        // console.log('newTechWeeklyStart', newTechWeeklyStart + (newTechWeeklyStart * 1.042));


        // Calculate differences and revenues
        let revenues = [];

        for (let i = 0; i < months; i++) {
          let diff;
          // let diff = rollingRevenueForExperiencedTech[i] - newHireWeeklyAmounts[i];
          if (i === 0) {
            diff = newHireWeeklyAmounts[i];
          } else {
            diff = revenues[i - 1] + newHireWeeklyAmounts[i];
          }

          revenues.push(diff);
        }

        console.table(revenues);

        const totalOfExperiencedTech = rollingRevenueForExperiencedTech[rollingRevenueForExperiencedTech.length - 1];
        const totalOfNewTech = revenues[revenues.length - 1];
        const lostRevenue =  totalOfExperiencedTech - totalOfNewTech;
        console.log('totalOfExperiencedTech', totalOfExperiencedTech);
        console.log('totalOfNewTech', totalOfNewTech);
        console.log('lostRevenue', lostRevenue);

        // GRAPH DATA
        // Cost Of Turnover
        this.totalCostOfTurnover = {
          labels: ['Cost of Turnover'],
          datasets: [{
            label: 'Lost Production Costs',
            data: [lostRevenue],
            backgroundColor: '#00095b'
          }, {
            label: 'Vacancy Costs',
            data: [this.vacancyCostLoss],
            backgroundColor: '#6e6e6e'
          },{
            label: 'Recruiting Costs',
            data: [this.totalInterviewingRecruitingCost],
            backgroundColor: '#1700f4'
          },],
        };

        // Lost Production Costs
        this.lostProductionCosts = {
          labels: ['Experienced Technician', 'New Technician'],
          datasets: [{
            label: 'New Technician',
            data: [0, totalOfNewTech],
            backgroundColor: '#00095b'
          }, {
            label: 'Experienced Technician',
            data: [totalOfExperiencedTech, 0],
            backgroundColor: '#6e6e6e'
          },{
            label: 'Lost Production',
            data: [0, lostRevenue],
            backgroundColor: '#1700f4'
          },]
        };


      },
      calculateTotalLostProductionCostFromTechnicianTurnoverProfit() {
        if (this.debugFlag) {
          this.testGrowthRates();
        }

        // Calculate how experienced tech
        const months = 12;
        const experiencedTechMonthly = this.days_worked_weekly * this.calculations.profit.experiencedTechnician * ( this.weeks_worked_yearly / months) * this.turnover_rate;
        const newTechMonthly = this.days_worked_weekly * this.calculations.profit.newTechnician * ( this.weeks_worked_yearly / months) * this.turnover_rate;
        console.log('experiencedTechMonthly', experiencedTechMonthly);
        console.log('newTechMonthly', newTechMonthly);

        // Calculating Experienced Technician Cost for 12 months
        let rollingProfitForExperiencedTech = [];

        for (let i = 0; i < months; i++) {
          let calc;
          if (rollingProfitForExperiencedTech.length === 0) {
            calc = experiencedTechMonthly;
          } else {
            calc = rollingProfitForExperiencedTech[i - 1] + experiencedTechMonthly;
          }
          rollingProfitForExperiencedTech.push(calc)
        }

        console.log('rollingProfitForExperiencedTech', rollingProfitForExperiencedTech);

        // Vacancy Months per position (doesn't have an input so use turnover_rate)
        // const growthRate = 0.04223388250834771;
        let growthRate;
        if (this.avg_time_until_full_prod <= 0) {
          growthRate = 0
        } else {
          // growthRate = Math.pow(parseInt(this.calculations.profit.experiencedTechnician) / parseInt(this.calculations.profit.newTechnician), (1 / parseInt(this.avg_time_until_full_prod))) - 1; // dynamic
          // growthRate = 0.044826106;// from excel
          // // growthRate = 0.04223388250834771;
          // console.log('growthRate ', growthRate )

          this.costOfTurnoverProfit();
          growthRate = parseFloat((Math.pow(parseFloat(this.calculations.profit.experiencedTechnician.toFixed(2)) / parseFloat(this.calculations.profit.newTechnician.toFixed(2)), (1 / parseInt(this.avg_time_until_full_prod))) - 1).toFixed(8)); // dynamic
          // growthRate = 0.044826106;// from excel
        }
        // const growthRate = 0.048;
        let newHireWeeklyAmounts = [];


        const vacancyDays = parseInt(this.vacancy_days);
        const positionsToFill = parseInt(this.turnover_rate);
        const totalVacancyDays = vacancyDays * positionsToFill;
        const vacancyMonths = Math.ceil(totalVacancyDays / 30);

        // let newTechWeeklyStart = Math.pow((newTechMonthly * (1 + growthRate)), (1 - parseInt(this.turnover_rate)))
        // let newTechWeeklyStart = Math.pow((newTechMonthly * (1 + growthRate)), (1 - vacancyMonths))
        // console.log('newTechWeeklyStart', newTechWeeklyStart);

        console.log('vacancyMonths', vacancyMonths);


        // IF STARTS
        let h51; // experiencedTechMonthly

        // console.log('First IF', Math.pow(this.weeks_worked_yearly * (1 + growthRate), (this.days_worked_weekly - vacancyMonths)));
        const firstIF = Math.pow(this.weeks_worked_yearly * (1 + growthRate), (this.days_worked_weekly - vacancyMonths));

        // IF($F$49*(1+$H$63)^($F51-$D$48)>$H$51,$H$51,
        if (firstIF > experiencedTechMonthly) {
          h51 = firstIF;
          console.log('FIRST IF', h51);
        }

        const vacancyMonthsPerPosition = Math.ceil(vacancyMonths / this.turnover_rate);
        const interviewingStatistics = this.hrs_per_interview_candidate + this.hrs_per_candidate_resume_review + this.hrs_per_job_posting + this.hrs_for_legal_paperwork_candidate;
        console.log('interviewingStatistics', interviewingStatistics);
        // ADD these
        // hrs_per_interview_candidate: 1,
        //   hrs_per_candidate_resume_review: 1,
        //   hrs_per_job_posting: 0.4,
        //   hrs_for_legal_paperwork_candidate: 1,

        // IF($F51=$D$48,
        // ((($D$48*30)-$D$35)/30)*$F$49,
        if (1 === vacancyMonthsPerPosition) {
          // h51 = ((((vacancyMonthsPerPosition * 30) * interviewingStatistics) - this.vacancy_days) / 30) * this.weeks_worked_yearly;
          h51 = (((vacancyMonthsPerPosition * 30) - this.vacancy_days) / 30) * newTechMonthly;
            console.log('second IF', h51);
        }
        // IF($F51>$D$48,
        // $F$49*(1+$H$63)^($F51-$D$48),
        if (1 > vacancyMonthsPerPosition) {
          h51 =
          console.log('third IF', h51);
        }
        // IF($F51<$D$48,0,0))))
        if (1 < vacancyMonthsPerPosition) {
          h51 = 0;
          console.log('fourth IF', h51);
        }

        // IF ENDS
        console.log('H51', h51);


        // Now that we have 51, use this as our starting number
        // =IF($F$49*(1+$H$63)^($F52-$D$48)>$H$51,$H$51,IF($F52=$D$48,((($D$48*30)-$D$35)/30)*$F$49,IF($F52>$D$48,$F$49*(1+$H$63)^($F52-$D$48),IF($F52<$D$48,0,0))))
        let newTechWeeklyStart = h51;

        // Calculating Experienced Technician Cost for 12 months
        for (let i = 0; i < months; i++) {
          let calc;

          // =IF($F$49*(1+$H$63)^($F52-$D$48)>$H$51,$H$51,
          // IF($F52=$D$48,((($D$48*30)-$D$35)/30)*$F$49,
          // IF($F52>$D$48,$F$49*(1+$H$63)^($F52-$D$48),
          // IF($F52<$D$48,0,0))))

          if (newHireWeeklyAmounts.length === 0) {
            calc = newTechWeeklyStart;
          } else if (newHireWeeklyAmounts.length === 1) {
            calc = Math.pow((newTechMonthly * (1 + growthRate)), ((i + 1) - vacancyMonthsPerPosition));
          } else {
            calc = newHireWeeklyAmounts[i - 1] + (newHireWeeklyAmounts[i - 1] * growthRate) ;

            if (calc >= experiencedTechMonthly) {
              calc = experiencedTechMonthly;
            }
          }

          newHireWeeklyAmounts.push(calc)
        }

        console.table(newHireWeeklyAmounts);
        console.table(rollingProfitForExperiencedTech);




        // const vacancyDays = parseInt(this.vacancy_days);
        // const positionsToFill = parseInt(this.turnover_rate);
        // const totalVacancyDays = vacancyDays * positionsToFill;
        // const vacancyMonths = Math.ceil(totalVacancyDays / 30);

        // const vacancyMonthsPerPosition = Math.ceil()
        // this.weeks_worked_yearly * (1 + growthRate) ^ (1 - vacancyMonths) >

          // console.log('MATHPOW', Math.pow(this.weeks_worked_yearly * (1 + growthRate),(1 - vacancyMonths)));
        // if () {
        //
        // }

        // Matching first IF statement in EXCEL
        if (newTechWeeklyStart === this.turnover_rate) {
          // newTechWeeklyStart = (((this.turnover_rate * 30) - this.vacancy_days) / 30) * newTechMonthly
          //
          // // Calculating Experienced Technician Cost for 12 months
          // for (let i = 0; i < months; i++) {
          //   let calc;
          //   if (newHireWeeklyAmounts.length === 0) {
          //     calc = newTechWeeklyStart;
          //   } else if (newHireWeeklyAmounts.length === 1) {
          //     calc = Math.pow((newTechMonthly * (1 + growthRate)), (2 - this.turnover_rate));
          //   } else {
          //     calc = newHireWeeklyAmounts[i - 1] + (newHireWeeklyAmounts[i - 1]  * growthRate) ;
          //   }
          //
          //   newHireWeeklyAmounts.push(calc)
          // }
          //
          // console.table(newHireWeeklyAmounts);
          // console.table(rollingProfitForExperiencedTech);
        }

        // console.log('tesss', newTechWeeklyStart);
        // console.log('newTechWeeklyStart', newTechWeeklyStart);
        // console.log('newTechWeeklyStart', newTechWeeklyStart + (newTechWeeklyStart * 1.042));


        // Calculate differences and revenues
        let profits = [];

        for (let i = 0; i < months; i++) {
          let diff;
          // let diff = rollingRevenueForExperiencedTech[i] - newHireWeeklyAmounts[i];
          if (i === 0) {
            diff = newHireWeeklyAmounts[i];
          } else {
            diff = profits[i - 1] + newHireWeeklyAmounts[i];
          }

          profits.push(diff);
        }

        console.log('***** newHireWeeklyAmounts', newHireWeeklyAmounts);
        console.table(profits);

        const totalOfExperiencedTech = rollingProfitForExperiencedTech[rollingProfitForExperiencedTech.length - 1];
        const totalOfNewTech = profits[profits.length - 1];
        const lostRevenue =  totalOfExperiencedTech - totalOfNewTech;
        console.log('totalOfExperiencedTech', totalOfExperiencedTech);
        console.log('totalOfNewTech', totalOfNewTech);
        console.log('lostRevenue', lostRevenue);

        // GRAPH DATA
        // Cost Of Turnover
        this.totalCostOfTurnover = {
          labels: [],
          datasets: [{
            label: 'Lost Production Costs',
            data: [lostRevenue],
            backgroundColor: '#00095b'
          }, {
            label: 'Vacancy Costs',
            data: [this.vacancyCostLoss],
            backgroundColor: '#6e6e6e'
          },{
            label: 'Recruiting Costs',
            data: [this.totalInterviewingRecruitingCost],
            backgroundColor: '#1700f4'
          },]
        };

        // Lost Production Costs
        this.lostProductionCosts = {
          labels: ['Experienced Technician', 'New Technician'],
          datasets: [{
            label: 'New Technician',
            data: [0, totalOfNewTech],
            backgroundColor: '#00095b'
          }, {
            label: 'Experienced Technician',
            data: [totalOfExperiencedTech, 0],
            backgroundColor: '#6e6e6e'
          },{
            label: 'Lost Production',
            data: [0, lostRevenue],
            backgroundColor: '#1700f4'
          },]
        };

      }
    },
    computed: {},
    watch: {
      new_hire(newVal)  {
        let experiencedHire;
        if (this.experienced_hire) {
          experiencedHire = this.experienced_hire;
        } else {
          experiencedHire = 0;
        }

        if (newVal) {
          this.turnover_rate = parseInt(newVal) + parseInt(experiencedHire);
        } else {
          this.turnover_rate = parseInt(experiencedHire);
        }
      },
      experienced_hire(newVal) {
        let newHire;
        if (this.new_hire) {
          newHire = this.new_hire;
        } else {
          newHire = 0;
        }

       if (newVal) {
         this.turnover_rate = parseInt(newVal) + parseInt(newHire);
       } else {
         this.turnover_rate = parseInt(newHire);
       }
      },
      // PROFICINCIES
      // proficiency_ratio_new_hire
      productivity_ratio_new_hire(newVal) {
        let productivity_ratio_new_hire;
        let initial_efficiency_new_hire;

        // Check productivity_ratio_new_hire
        productivity_ratio_new_hire = newVal;

        if (this.initial_efficiency_new_hire) {
          initial_efficiency_new_hire = this.initial_efficiency_new_hire;
        } else {
          initial_efficiency_new_hire = 0;
        }

        if (productivity_ratio_new_hire && initial_efficiency_new_hire) {
          this.proficiency_ratio_new_hire = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_new_hire)) * this.convertPercent(parseFloat(initial_efficiency_new_hire))) * 100);
        } else {
          this.proficiency_ratio_new_hire = null;
        }
      },
      initial_efficiency_new_hire(newVal) {
        let productivity_ratio_new_hire;
        let initial_efficiency_new_hire;

        // Check productivity_ratio_new_hire
        initial_efficiency_new_hire = newVal;

        if (this.productivity_ratio_new_hire) {
          productivity_ratio_new_hire = this.productivity_ratio_new_hire;
        } else {
          productivity_ratio_new_hire = 0;
        }

        if (productivity_ratio_new_hire && initial_efficiency_new_hire) {
          this.proficiency_ratio_new_hire = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_new_hire)) * this.convertPercent(parseFloat(initial_efficiency_new_hire))) * 100);
        } else {
          this.proficiency_ratio_new_hire = null;
        }
      },
      // proficiency_ratio_experienced_hire
      productivity_ratio_experienced_hire(newVal) {
        let productivity_ratio_experienced_hire;
        let initial_efficiency_experienced_hire;

        // Check productivity_ratio_new_hire
        productivity_ratio_experienced_hire = newVal;

        if (this.initial_efficiency_experienced_hire) {
          initial_efficiency_experienced_hire = this.initial_efficiency_experienced_hire;
        } else {
          initial_efficiency_experienced_hire = 0;
        }

        if (productivity_ratio_experienced_hire && initial_efficiency_experienced_hire) {
          this.proficiency_ratio_experienced_hire = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_experienced_hire)) * this.convertPercent(parseFloat(initial_efficiency_experienced_hire))) * 100);
        } else {
          this.proficiency_ratio_experienced_hire = null;
        }
      },
      initial_efficiency_experienced_hire(newVal) {
        let productivity_ratio_experienced_hire;
        let initial_efficiency_experienced_hire;

        // Check productivity_ratio_new_hire
        initial_efficiency_experienced_hire = newVal;

        if (this.productivity_ratio_experienced_hire) {
          productivity_ratio_experienced_hire = this.productivity_ratio_experienced_hire;
        } else {
          productivity_ratio_experienced_hire = 0;
        }

        if (productivity_ratio_experienced_hire && initial_efficiency_experienced_hire) {
          this.proficiency_ratio_experienced_hire = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_experienced_hire)) * this.convertPercent(parseFloat(initial_efficiency_experienced_hire))) * 100);
        } else {
          this.proficiency_ratio_experienced_hire = null;
        }
      },
      // proficiency_ratio_dealership
      productivity_ratio_at_dealership(newVal) {
        let productivity_ratio_at_dealership;
        let eff_ratio_at_dealership;

        // Check productivity_ratio_new_hire
        productivity_ratio_at_dealership = newVal;

        if (this.eff_ratio_at_dealership) {
          eff_ratio_at_dealership = this.eff_ratio_at_dealership;
        } else {
          eff_ratio_at_dealership = 0;
        }

        if (productivity_ratio_at_dealership && eff_ratio_at_dealership) {
          this.proficiency_ratio_dealership = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_at_dealership)) * this.convertPercent(parseFloat(eff_ratio_at_dealership))) * 100);
        } else {
          this.proficiency_ratio_dealership = null;
        }
      },
      eff_ratio_at_dealership(newVal) {
        let productivity_ratio_at_dealership;
        let eff_ratio_at_dealership;

        // Check productivity_ratio_new_hire
        eff_ratio_at_dealership = newVal;

        if (this.productivity_ratio_at_dealership) {
          productivity_ratio_at_dealership = this.productivity_ratio_at_dealership;
        } else {
          productivity_ratio_at_dealership = 0;
        }

        if (productivity_ratio_at_dealership && eff_ratio_at_dealership) {
          this.proficiency_ratio_dealership = Math.ceil((this.convertPercent(parseFloat(productivity_ratio_at_dealership)) * this.convertPercent(parseFloat(eff_ratio_at_dealership))) * 100);
        } else {
          this.proficiency_ratio_dealership = null;
        }
      },
    }

  }
</script>


<style lang="scss" scoped>
  input[type=number] {
    background: rgb(255, 255, 255);
    border-radius: 0px;
    /*border: 1px solid rgb(0, 130, 0);*/
    border: 1px solid rgb(110, 110, 110);
    width: 65px; // make room for number ticker
  }

  .section-header {
    color: $fordBlueDark;
    font-family: FordAntenna-Medium;
    font-size: 20px;
    font-weight: 500;
    height: 24px;
    letter-spacing: 0px;
    line-height: 24px;
    margin: 47px 0 20px 0;
  }

  .input-header {
    background: $fordBlueDark;
    border-radius: 0;
    width: 100%;
    color: white;
    padding: 12px;
    font-family: FordAntenna-Regular;
    font-size: 16px;
    font-weight: normal;
    letter-spacing: 1px;
    line-height: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0;

    span {
      color: white;
      input {
        margin: 0 5px 0 0;
      }

      label {
        color: white !important;
      }
    }
  }

  .form-group {
    display: flex;
    label {
      width: 100%;
    }
  }


  .input-container {
    background: white;
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #f2f2f2;
    padding: 12px;
    height: auto;
    .input {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      /*height: 48px;*/

      input[type=number] {
        color: $fordBlueDark !important;
        background: rgb(255, 255, 255);
        border-radius: 0px;

        width: 65px; // make room for number ticker

        &.focused {
          box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
          &.valid {
            border: 1px solid rgb(0, 130, 0) !important;
          }

          &.invalid {
            border: 1px solid #d62d0a !important;
          }
        }
        &.error {
          border: 1px solid #d62d0a;
        }

        &.empty {
          border: 1px dashed black;
        }

        &.default {
          background: #f2f2f2;
        }
      }
    }

    .error-msg {
      color: #d62d0a;
      font-family: FordAntenna-Regular;
      font-size: 12px;
      font-weight: normal;
      letter-spacing: 1px;
      margin: 0;
      display: flex;
      align-items: center;

      * {
        color: #d62d0a;
        margin: 0 5px 0 0;
      }
    }
  }

  .assumptions-container {
    background: #f2f2f2;
    border: none;

    .section-header {
      margin: 29px 0 0 0;
    }

    .input-header {
      margin: 30px 0 0 0;

      &:first-of-type {
        margin: 16px 0 0 0;
      }
    }
  }

  .assumption-toggle {
    color: $fordBlueDark;
    width: 100%;
    background: white;
    font-family: FordAntenna-Bold;
    font-size: 16px;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 24px;
    text-align: left;
    border: none;
    border-top: 1px solid black;
    border-bottom: 1px solid black;
    padding: 14px;
    margin: 32px 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 0;

    &:hover {
      outline: 0;
      background: white;
      color: $fordBlueHover;
      text-decoration: none !important;
      /*border: none;*/
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }

    &:focus {
      outline: 0 !important;
      background: white;
      color: $fordBlueHover !important;
      text-decoration: none !important;
      /*border: none !important;*/
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none !important;;
    }

    &:active {
      outline: 0;
      background: white !important;
      color: $fordBlueHover;
      text-decoration: none !important;
      /*border: none;*/
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
    }

    span {
      font-size: 16px;
      color: $fordBlueDark;
    }

    .collapse {
      margin-top: 0;
    }
  }

  .override-text {
    color: $fordBlueHover;
    font-family: FordAntenna-Regular;
    font-size: 14px;
    font-weight: normal;
    height: 63px;
    letter-spacing: 1px;
    line-height: 21px;
    margin: 100px 0 0 0;
  }
</style>

<style lang="scss">
  .ford-btn {
    color: $fordBlueDark;
    font-family: FordAntennaCond-Regular;
    font-size: 18px;
    font-weight: normal;
    height: 40px;
    letter-spacing: 1px;
    line-height: 0;
    text-align: center;
    background: white;
    border: 1px solid #6E6E6E;
    border-radius: 20px;
    padding: 12px 32px;
    /*transform: scale(1); !* you need a scale here to allow it to transition in both directions *!*/
    transition: 0.3s padding ease;

    &.active {
      background: $fordBlueDark;
      border:  $fordBlueDark;
      color: rgb(255, 255, 255);
    }
    &:hover {
      background: $fordBlueHover;
      padding: 14px 36px;
      text-decoration: none !important;
      color: rgb(255, 255, 255);
      /*transform: scale(.2); !* you need a scale here to allow it to transition in both directions *!*/
    }

    &:focus {
      outline: 0;
      box-shadow: none;
    }

    &:active {
      outline: 0;
      box-shadow: none;
    }
  }

  .tooltip-container {
    display: flex;
    align-items: center;

    label {
      margin: 0 5px 0 0 !important;
    }
  }

  label {
    text-transform: unset !important;
  }
</style>
